import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
// Utility for class merging if not already present
function classNames(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-green-500 text-black hover:bg-green-400 hover:scale-105 shadow-[0_0_20px_rgba(34,197,94,0.4)] border-2 border-green-500',
    secondary: 'bg-zinc-800 text-white hover:bg-zinc-700 border-2 border-zinc-700 hover:border-zinc-600',
    outline: 'bg-transparent text-green-500 border-2 border-green-500 hover:bg-green-500/10'
  };
  const sizes = {
    sm: 'text-xs px-4 py-2 rounded-md',
    md: 'text-sm px-6 py-3 rounded-lg',
    lg: 'text-base px-8 py-4 rounded-xl',
    xl: 'text-lg px-10 py-5 rounded-xl'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classNames(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-248">
      {children}
    </motion.button>;
}